export default __webpack_public_path__ + "static/hodlx-c06285f5b71b215b2a4ac5c5daa52aae.png";